module.exports = __webpack_public_path__ + "img/20210420_121941.a09deb24.jpg";